import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUpload } from "react-icons/fa";
import CodUploadPoopup from "./CodUploadPoopup";
import EmployeeAuthModal from "../../employeeAuth/EmployeeAuthModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FiCheckCircle,
  FiCreditCard,
  FiClock,
  FiArrowRight,
  FiArrowLeft,
} from "react-icons/fi";
import ThreeDotLoader from "../../Loader"
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CODRemittanceOrder = ({ isSidebarAdmin }) => {
  const [page, setPage] = useState(1); // Track current page
  const [limit, setLimit] = useState(20); // You can make this dynamic if needed
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [totalremitted, setTotalRemitted] = useState(0);
  const [pendingremitted, setPendingRemitted] = useState(0);
  const [paidremitted, setPaidRemitted] = useState(0);
  const [upload, setUpload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const rowsPerPage = 10;
  // const [remited, setremited] = useState({});
  const [remitedData, setremitedData] = useState([]);
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState("");
  const [userNameFilter, setUserNameFilter] = useState("");
  const [remittanceIdFilter, setRemittanceIdFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRemittanceIds, setSelectedRemittanceIds] = useState([]);
  const [employeeAccess, setEmployeeAccess] = useState({
    isAdmin: false,
    canView: false,
    canAction: false,
  });
  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
  useEffect(() => {
    const fetchAccessAndData = async () => {
      setLoading(true);
      try {
        if (isSidebarAdmin) {
          setEmployeeAccess({ isAdmin: true, canView: true, canAction: true });
          setShowEmployeeAuthModal(false);
        } else {
          const [session, token] = document.cookie.split("=");
          if (!token) {
            setShowEmployeeAuthModal(true);
            return;
          }
          const empRes = await axios.get(
            `${REACT_APP_BACKEND_URL}/staffRole/verify`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const employee = empRes.data.employee;
          // const isAdmin = !!employee?.isAdmin;
          const canView =
            !!employee?.accessRights?.finance?.["Seller COD Remittance"]?.view;
          const canAction =
            !!employee?.accessRights?.finance?.["Seller COD Remittance"]
              ?.action;
          setEmployeeAccess({ canView, canAction });
          if (!canView) {
            setShowEmployeeAuthModal(true);
            return;
          }
          setShowEmployeeAuthModal(false);
        }

        // Fetch remittance data only if access is allowed
        const [session, token] = document.cookie.split("=");
        if (!token) {
          setShowEmployeeAuthModal(true);
          return;
        }
        let url = `${REACT_APP_BACKEND_URL}/cod/getAdminCodRemitanceData?page=${page}`;
        if (limit) url += `&limit=${limit}`;
        if (userNameFilter) url += `&userNameFilter=${userNameFilter}`;
        if (remittanceIdFilter)
          url += `&remittanceIdFilter=${remittanceIdFilter}`;
        if (statusFilter) url += `&statusFilter=${statusFilter}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          setTotalRemitted(response.data.data.totalCODAmount);
          setPendingRemitted(response.data.data.pendingCODAmount);
          setPaidRemitted(response.data.data.paidCODAmount);
          setremitedData(response.data.data.orders);
          setTotalPages(response.data.totalPages);
        }
      } catch (error) {
        setShowEmployeeAuthModal(true);
      } finally {
        setLoading(false);
      }
    };
    fetchAccessAndData();
  }, [
    isSidebarAdmin,
    page,
    limit,
    refresh,
    userNameFilter,
    remittanceIdFilter,
    statusFilter,
  ]);
  const RemittanceDetails = (id) => {
    navigate(`/dashboard/billing/sellerRemittanceData/${id}`);
  };
  const handleCodRemittanceUpload = () => {
    setUpload(true);
  };

  // Function to format date with day name
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Pagination logic

  // const lastCODRemitted =
  //   currentRows.length > 0 ? currentRows[0].codAvailable : 0;
  const handleCheckboxChange = (id) => {
    setSelectedRemittanceIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // The main function to export selected remittances to Excel
  const handleExport = () => {
    if (selectedRemittanceIds.length === 0) {
      alert("Please select at least one row to export.");
      return;
    }

    const exportData = remitedData.filter(
      (item) => selectedRemittanceIds.includes(item.remitanceId) // <-- Match this key with your data
    );

    const formattedData = exportData.map((row) => ({
      Date: formatDate(row.date),
      "Remittance ID": row.remitanceId,
      "COD Available": row?.orderDetails?.codcal || 0,
      "Amount Credited to Wallet": row.amountCreditedToWallet,
      "Early COD Charges": row.earlyCodCharges,
      "Adjusted Amount": row.adjustedAmount,
      "Remittance Amount": row.totalCod,
      Status: row.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    worksheet["!cols"] = [
      { wch: 25 }, // Date
      { wch: 20 }, // Remittance ID
      { wch: 20 }, // COD Available
      { wch: 15 }, // Amount Credited to Wallet
      { wch: 18 }, // Early COD Charges
      { wch: 25 }, // Adjusted Amount
      { wch: 20 }, //Remittance Amount
      { wch: 15 }, // Status
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Remittance");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, "RemittanceExport.xlsx");

    // Optionally reset selection after download
    setSelectedRemittanceIds([]);
  };

  const cardData = [
    {
      label: "Total COD Amount",
      value: `₹${(totalremitted || 0).toFixed(2)}`,
      icon: <FiCreditCard className="text-white" size={20} />,
    },
    {
      label: "Paid COD Amount",
      value: `₹${(paidremitted || 0).toFixed(2)}`,
      icon: <FiCheckCircle className="text-white" size={20} />,
    },
    {
      label: "Pending COD Amount",
      value: `₹${(pendingremitted || 0).toFixed(2)}`,
      icon: <FiClock className="text-white" size={20} />,
    },
  ];

  return (
    <div className="min-h-screen">
      {/* {!isSidebarAdmin && showEmployeeAuthModal && (
        <EmployeeAuthModal
          employeeModalShow={showEmployeeAuthModal}
          employeeModalClose={() => {
            setShowEmployeeAuthModal(false);
            window.history.back();
          }}
        />
      )} */}
      {(isSidebarAdmin || employeeAccess.isAdmin || employeeAccess.canView) && (
        <>
          {/* Header Cards */}
          {/* Header */}

          {/* ✅ Mobile View: One card with all 3 values, no icons */}
          <div className="block sm:hidden my-2">
            <div className="bg-white rounded-lg border-2 border-[#0CBB7D] p-4 shadow-md space-y-2">
              {cardData.map((card, index) => (
                <div key={index} className="flex justify-between items-center">
                  <span className="text-[12px] text-gray-500 font-[600]">{card.label}</span>
                  <span className="text-[12px] font-[600] text-gray-700">{card.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ✅ Desktop View: Grid with individual icon cards */}
          <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 my-2">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="flex items-center justify-start text-start gap-4 p-2 bg-white rounded-lg border-2 border-[#0CBB7D] hover:shadow-lg transition-shadow duration-300"
              >
                <div className="bg-[#0CBB7D] text-white p-2 rounded-full">
                  {card.icon}
                </div>
                <div className="flex flex-col">
                  <span className="text-[12px] font-[600] text-gray-700">{card.value}</span>
                  <span className="text-[14px] text-gray-500">{card.label}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap justify-between">
            {/* desktop */}
            {/* Search by User Name */}
            <div className="flex justify-between sm:flex-row flex-col w-full">
              <div className="flex gap-2 w-full sm:flex-row flex-col">
                <div className="flex gap-2">
                  <input
                    type="text"
                    placeholder="Search by User Name"
                    className="w-full md:w-[250px] h-9 px-3 text-[12px] font-[600] border-2 placeholder:text-gray-500 rounded-lg focus:outline-none placeholder:text-[12px]"
                    value={userNameFilter}
                    onChange={(e) => setUserNameFilter(e.target.value)}
                  />

                  {/* Search by Remittance ID */}
                  <input
                    type="text"
                    placeholder="Search by Remittance ID"
                    className="w-full md:w-[250px] h-9 px-3 text-[12px] font-[600] border-2 placeholder:text-gray-500 rounded-lg focus:outline-none placeholder:text-[12px]"
                    value={remittanceIdFilter}
                    onChange={(e) => setRemittanceIdFilter(e.target.value)}
                  />
                </div>

                <div className="flex gap-2 justify-between w-full">
                  {/* Filter by Status */}
                  <select
                    className="sm:w-[150px] text-gray-500 h-9 px-3 py-2 w-full border-2 rounded-lg text-left text-[12px] bg-white flex justify-between items-center font-[600]"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                  >
                    <option value="">Status</option>
                    <option value="Paid">Paid</option>
                    <option value="Pending">Pending</option>
                  </select>
                  <div className="w-full gap-2 sm:w-auto mb-12 sm:mb-0 flex flex-row items-center sm:items-start justify-end">
                    <button
                      className="h-9 px-3 sm:text-[12px] text-[10px] border-2 rounded-lg font-[600] text-white border-[#0CBB7D] bg-[#0CBB7D] hover:bg-green-500 transition whitespace-nowrap"
                      onClick={() => {
                        setRemittanceIdFilter("");
                        setUserNameFilter("");
                        setStatusFilter("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      disabled={selectedRemittanceIds.length === 0}
                      className={`flex items-center justify-center ${selectedRemittanceIds.length === 0
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#0CBB7D]"
                        } text-white px-3 h-9 rounded-lg text-[10px] sm:text-[12px] font-[600] transition-all duration-200 w-full md:w-auto`}
                      onClick={handleExport}
                    >
                      Export
                    </button>

                    <div
                      onClick={() => {
                        if (
                          isSidebarAdmin ||
                          employeeAccess.isAdmin ||
                          employeeAccess.canAction
                        ) {
                          handleCodRemittanceUpload();
                        } else {
                          setShowEmployeeAuthModal(true);
                        }
                      }}
                      className="flex flex-col items-center sm:items-start"
                    >
                      <label
                        className={`cursor-pointer flex h-9 items-center gap-2 text-[10px] sm:text-[12px] font-[600] px-3 py-2 rounded-lg border-2 transition
      ${isSidebarAdmin || employeeAccess.isAdmin || employeeAccess.canAction
                            ? "text-white bg-[#0CBB7D] border-[#0CBB7D] hover:bg-green-500"
                            : "text-gray-400 bg-gray-100 border-gray-300 cursor-not-allowed"
                          }`}
                      >
                        <FaUpload className="text-white text-[10px] sm:text-[12px] font-[600]" />
                        <span>Upload</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="block w-full sm:hidden">
              <div className="px-2 w-full py-1 bg-green-200 rounded-lg mt-[-40px] flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={
                    selectedRemittanceIds.length === remitedData.length &&
                    remitedData.length > 0
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedRemittanceIds(
                        remitedData.map((row) => row.remitanceId)
                      );
                    } else {
                      setSelectedRemittanceIds([]);
                    }
                  }}
                  className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                />
                <span className="text-[10px] font-[600] text-gray-500">Select All</span>
              </div>
            </div>


          </div>

          <div className="hidden md:block relative mt-2">
            <table
              className="min-w-full 
         bg-white rounded-lg shadow-md table-auto"
            >
              {/* Table Head */}
              <thead>
                <tr className="text-white border border-[#0CBB7D] bg-[#0CBB7D] text-[12px] font-[600]">
                  <th className="py-2 px-3 text-left">
                    <div className="flex">
                      <input
                        type="checkbox"
                        checked={
                          selectedRemittanceIds.length === remitedData.length &&
                          remitedData.length > 0
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRemittanceIds(
                              remitedData.map((row) => row.remitanceId)
                            );
                          } else {
                            setSelectedRemittanceIds([]);
                          }
                        }}
                        className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                      />
                      <div className="ml-4">Date</div>
                    </div>
                  </th>
                  <th className="py-2 px-3 text-left">User</th>
                  <th className="py-2 px-3 text-center">Remittance ID</th>
                  <th className="py-2 px-3 text-center">COD Available</th>
                  <th className="py-2 px-3 text-center">
                    Amount Credited to Wallet
                  </th>
                  <th className="py-2 px-3 text-center">Adjusted Amount</th>
                  <th className="py-2 px-3 text-center">Early COD Charges</th>
                  <th className="py-2 px-3 text-center">Remittance Amount</th>
                  <th className="py-2 px-3 text-center">COD Status</th>
                </tr>
              </thead>
              {/* Table Body */}
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="text-center py-6">
                      <ThreeDotLoader />
                    </td>
                  </tr>
                ) : remitedData.length > 0 ? (
                  remitedData.map((row, index) => (
                    <tr
                      key={index}
                      className="border-t hover:bg-gray-50 border-gray-300 text-gray-500 transition-all text-[12px] font-[400] relative text-center"
                    >
                      <td className="py-2 px-3 whitespace-nowrap">
                        <div className="flex">
                          <input
                            type="checkbox"
                            checked={selectedRemittanceIds.includes(
                              row.remitanceId
                            )}
                            onChange={() =>
                              handleCheckboxChange(row.remitanceId)
                            }
                            className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                          />
                          <div className="ml-4">{formatDate(row.date)}</div>
                        </div>
                      </td>
                      <td className="py-2 px-3 font-semibold whitespace-nowrap text-left">
                        {row.userName}
                      </td>
                      <td className="py-2 px-3 whitespace-normal">
                        <div
                          onClick={() => RemittanceDetails(row.remitanceId)}
                          className="text-[#0CBB7D] font-semibold hover:underline cursor-pointer"
                        >
                          {row.remitanceId}
                        </div>
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap">
                        {`₹${(Number(row?.orderDetails?.codcal) || 0).toFixed(
                          2
                        )}`}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap">
                        {`₹${(Number(row?.amountCreditedToWallet) || 0).toFixed(
                          2
                        )}`}
                      </td>
                      {/* <td className="py-2 px-3 whitespace-nowrap">
                    {`₹${(Number(row?.earlyCodCharges) || 0).toFixed(2)}`}
                  </td> */}
                      <td className="py-2 px-3 whitespace-nowrap">
                        {`₹${(Number(row.adjustedAmount) || 0).toFixed(2)}`}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap">
                        {`₹${(Number(row.earlyCodCharges) || 0).toFixed(2)}`}
                      </td>
                      <td className="py-2 px-3 whitespace-nowrap">
                        {`₹${(Number(row.totalCod) || 0).toFixed(2)}`}
                      </td>
                      <td
                        className={`py-2 px-3 whitespace-nowrap ${row.status === "Paid"
                          ? "text-green-600"
                          : row.status === "Pending"
                            ? "text-orange-500"
                            : ""
                          }`}
                      >
                        {row.status}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4 text-gray-500">
                      No orders found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Mobile View */}
          <div className="md:hidden space-y-2 mt-[-20px]">
            {remitedData.map((row, index) => (
              <div
                key={index}
                className="bg-green-100 shadow-md text-gray-500 rounded-lg p-3 mt-2"
              >
                <div className="mt-2">
                  <div className="flex justify-between items-start">
                    <div className="flex text-[10px] font-[400]">
                      <input
                        type="checkbox"
                        checked={selectedRemittanceIds.includes(
                          row.remitanceId
                        )}
                        onChange={() => handleCheckboxChange(row.remitanceId)}
                        className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                      />
                      <p className="ml-2">Date:</p>
                      <p className="text-gray-500 ml-2">
                        {formatDate(row.date)}
                      </p>
                    </div>
                    <div className="flex">
                      <span
                        className={`text-[10px] font-[400] px-2 py-1 rounded-lg ${row.status === "Paid"
                          ? "bg-green-100 text-green-600"
                          : "bg-orange-100 text-orange-500"
                          }`}
                      >
                        {row.status}
                      </span>
                    </div>
                  </div>

                  <div className="flex">
                    <p className="text-[10px] font-[400] ml-5">Remittance ID:</p>
                    <p
                      className="ml-2 text-[10px] font-[400] text-[#0CBB7D] hover:underline"
                      onClick={() => RemittanceDetails(row.remitanceId)}
                    >
                      {row.remitanceId}
                    </p>
                  </div>

                  <div className="flex items-center mt-1 text-[10px] font-[400]">
                    <p className="font-semibold ml-5">User Name:</p>
                    <p className="ml-2 text-gray-700 font-[600] hover:underline truncate">
                      {row.userName}
                    </p>
                  </div>

                  <div className="mt-2 bg-white rounded-lg p-3 text-[10px] font-[400]">
                    {/* Amount Details */}
                    <div className="flex justify-between items-center">
                      <p className="text-gray-700 text-[10px] font-[400] text-left">Total COD:</p>
                      <p className="text-right text-[#0CBB7D]">{`₹${(
                        row.amountCreditedToWallet +
                        row.earlyCodCharges +
                        row.adjustedAmount +
                        row.totalCod
                      ).toFixed(2)}`}</p>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-500">-</span>
                      <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                        Amount Credited to Wallet:
                      </p>
                      <p className="text-right text-red-600">{`₹${(
                        row.amountCreditedToWallet || 0
                      ).toFixed(2)}`}</p>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-500">-</span>
                      <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                        Early COD Charges:
                      </p>
                      <p className="text-right text-red-600">{`₹${(
                        row.earlyCodCharges || 0
                      ).toFixed(2)}`}</p>
                    </div>

                    <div className="flex justify-between items-center">
                      <span className="text-gray-500 ">-</span>
                      <p className="text-[10px] font-[400] text-gray-500 text-left flex-1 pl-2">
                        Adjusted Amount:
                      </p>
                      <p className="text-red-600 text-right">{`₹${(
                        row.adjustedAmount || 0
                      ).toFixed(2)}`}</p>
                    </div>

                    {/* Divider */}
                    <div className="border-t my-1"></div>

                    {/* Final COD Available */}
                    <div className="flex justify-between items-center">
                      <p className="text-left text-[12px] font-[400]">COD Available:</p>
                      <p className="text-right text-[#0CBB7D]">{`₹${(
                        row.totalCod || 0
                      ).toFixed(2)}`}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
            <div className="flex items-center gap-2">
              <label
                htmlFor="limit"
                className="text-gray-700 text-[10px] font-[600]"
              >
                Show:
              </label>
              <select
                id="limit"
                value={limit}
                onChange={(e) => {
                  const selected = e.target.value;
                  if (selected === "All") {
                    setLimit(null); // null means no limit
                    setPage(1);
                  } else {
                    setLimit(parseInt(selected));
                    setPage(1); // reset to first page when changing limit
                  }
                }}
                className="px-3 py-2 border rounded-md text-[10px] font-[600]"
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={75}>75</option>
                <option value={100}>100</option>
                <option value="All">All</option>
              </select>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
              >
                <FiArrowLeft />
              </button>
              <span className="text-gray-700">
                Page {page} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={page === totalPages}
                className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
              >
                <FiArrowRight />
              </button>
            </div>
          </div>
          {upload && (
            <CodUploadPoopup
              onClose={() => setUpload(false)}
              setRefresh={setRefresh}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CODRemittanceOrder;
